export const helperText = `
You can embed the following merge fields inside the inputs which will be dynamically replaced with the 
merge fields of the group / user.
<br/>
<br/>
{{user_id}}
<br/>
{{mid_program_survey_link}}
<br/>
{{end_of_program_survey_link}}
<br/>
{{user_merge_field_1}}
<br/>
{{user_merge_field_2}}
<br/>
{{user_merge_field_3}}
<br/>
<br/>
{{group_number}}
<br/>
{{coach_name}}
<br/>
{{head_coach_name}}
<br/>
{{head_coach_email}}
<br/>
{{meeting_link}}
<br/>
{{meeting_id}}
<br/>
{{meeting_passcode}}
<br/>
{{meeting_time}}
<br/>
{{group_merge_field_1}}
<br/>
{{group_merge_field_2}}
<br/>
{{group_merge_field_3}}
`

export const pageAndHomeworkHelperText = `
You can embed anchor links using the following format where \`anchor_link\` is any alphanumeric anchor tag with no spaces.
<br/>
{{#anchor_link}}
<br/>
Links to the anchor tag can then be created with the editor with the value \`#anchor_link\`
<br/>
<br/>
-------------------------------------------------
<br/>
<br/>
${helperText}
`
